// import Config from '../config'
import http from './https'
export default {
  search (params) {
    return http.get('/certificate/selectCertificateDetailByHash', params)
  },
  joinUs (params) {
    return http.post('/member/join', params)
  
  }
}



// WEBPACK FOOTER //
// ./src/api/index.js